import {makeStyles} from "tss-react/mui";

export const useStyles = makeStyles()((theme) => {
  return {
    searchBarContainer: {
      position: "fixed",
      padding: '20px 0!important',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: "#FFF",
      zIndex: 999,
      boxShadow: '0px -4px 4px 0px rgba(0, 0, 0, 0.05)',
      transition: '0.15s all ease',
      [theme.breakpoints.down('md')]: {
        padding: '20px!important',
      },
      [theme.breakpoints.down('sm')]: {
        zIndex: 998,
      },
      'form': {
        '#searchBarBox': {
          padding: '10px 0!important',
          '#fieldContent': {
            lineHeight: 1
          }
        }
      }
    },
    noDestinationPicker: {
      maxWidth: '735px',
      margin: 'auto',
      [theme.breakpoints.down('lg')]: {
        maxWidth: '660px!important',
      }
    },
    destinationPicker: {
      maxWidth: '890px',
      margin: 'auto',
      [theme.breakpoints.down('lg')]: {
        maxWidth: '815px!important',
      }
    },
    searchBarContainerAfterScroll: {
      position: "fixed",
      padding: '0!important',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: "#FFF",
      zIndex: 999,
      boxShadow: '0px -4px 4px 0px rgba(0, 0, 0, 0.05)',
      transition: '0.15s all ease',
      [theme.breakpoints.down('md')]: {
        padding: '20px!important',
      },
      'h4': {
        display: 'none!important',
      },
      'form': {
        '#searchBarBox': {
          padding: '10px 0!important',
          '#fieldContent': {
            lineHeight: 1
          }
        }
      }
    },
    root: {
      '& .MuiPaper-root': {
        width: 470,
        backgroundColor: theme.palette.secondary.main,
        [theme.breakpoints.down('sm')]: {
          padding: '0',
          width: '-webkit-fill-available',
          backgroundColor: theme.palette.secondary.main
        }
      },
      '#fieldContent': {
        backgroundColor: '#FFF!important',
      },
      '#promoCode': {
        width: '100%!important',
        maxWidth: '100%!important',
        '& .MuiTextField-root': {
          backgroundColor: '#FFF!important',
          '& .MuiInputBase-root': {
            width: '100%',
            paddingLeft: '0!important'
          }
        }
      },
      h6: {
        fontFamily: theme.typography.h6.fontFamily + '!important'
      }
    },
  };
});
